import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import "maplibre-gl/dist/maplibre-gl.css";
import "../vendor/prism-next/map.css";
import "./styles/app.css";
// Light/dark mode + semantic palette: prism-next's ThemeProvider mirrors the
// <html> state that the no-flash <head> script (index.html) applies before paint,
// and powers the header's ThemeToggle / PaletteToggle. See components/theme/.
import { ThemeProvider } from "./components/theme/theme-provider";

import { TooltipProvider } from "./components/ui/tooltip";
import { Toaster } from "./components/ui/sonner";
import RootLayout from "./routes/root-layout";
import HomePage from "./routes/home-page";
import ShipmentsPage from "./routes/shipments-page";
import OrdersPage from "./routes/orders-page";
import { loader as indexRedirectLoader } from "./routes/index-redirect";

const router = createBrowserRouter([
  {
    path: "/",
    Component: RootLayout,
    children: [
      { index: true, loader: indexRedirectLoader, Component: HomePage },
      { path: "shipments", Component: ShipmentsPage },
      { path: "orders", Component: OrdersPage },
      {
        path: "admin",
        lazy: async () => {
          const { default: Component } = await import("./routes/admin-page");
          return { Component };
        },
      },
    ],
  },
]);

createRoot(document.getElementById("root")!).render(
  <ThemeProvider>
    <TooltipProvider>
      <RouterProvider router={router} />
      <Toaster />
    </TooltipProvider>
  </ThemeProvider>,
);
